const gtmTracking = () => {
  const triggerLabel = 'data-gtm-trigger'
  const triggerLabelClick = `[${triggerLabel}="click"]`
  const triggerElements = document.querySelectorAll(triggerLabelClick)

  // Handle click tracking
  triggerElements.forEach((item) => {
    item.addEventListener('click', (e) => {
      const data = e.currentTarget.dataset

      if (!data || !data.gtmTracking) {
        return
      }

      window.dataLayer.push(JSON.parse(data.gtmTracking))
    })
  })

  // Handle visibility tracking for #instruction
  const instructionBlock = document.querySelector('#instructions')
  let visibilityTimeout = null
  const firedEvents = new Set()

  if (instructionBlock) {
    const handleVisibility = (entries) => {
      const [entry] = entries
      if (entry.isIntersecting && !firedEvents.has('viewRecipeInstructions10s')) {
        visibilityTimeout = setTimeout(() => {
          if (!firedEvents.has('viewRecipeInstructions10s')) {
            window.dataLayer.push({
              event: 'viewRecipeInstructions10s'
            })
            firedEvents.add('viewRecipeInstructions10s')
          }
        }, 10000)
      } else if (visibilityTimeout) {
        clearTimeout(visibilityTimeout)
      }
    }

    const observer = new IntersectionObserver(handleVisibility, {
      threshold: 0.5
    })

    observer.observe(instructionBlock)
  }
}

export default gtmTracking
